import S from 's-js';
import { IAjax } from 'lib/ajax';
import escapeHtml from 'lib/escapeHtml';
import UOM from 'lib/UOM';

import { NullableMeasurement } from 'data/models/Measurement';
import { PierSettings } from 'data/models/PierSettings';
import { Vessel, VesselData } from 'data/models/Vessel';

import { PCCache } from 'data/PCCache';

import { Entrypoints } from 'core/app/entrypoints';

import { Typeahead } from '../typeahead/model';
import { TypeaheadServerSide } from '../typeahead/typeahead-server-side';

export interface LocalVesselSearchParams {
    onSelect : (v : Vessel) => void;
}

export type LocalVesselSearch = ReturnType<typeof LocalVesselSearch>;
export function LocalVesselSearch(
    pierSettings : PierSettings,
    ajax : IAjax,
    entrypoints : Entrypoints,
    data : PCCache,
    { onSelect } : LocalVesselSearchParams
) {
    const
        searchText = S.value(""),
        vesselTypeahead = new Typeahead<VesselData>({
            searchUrl: entrypoints.LocalVesselSearch,
            typeaheadOptions: {
                minLength: 3,
                highlight: true,
                hint: false
            },
            serverSideSearch: TypeaheadServerSide<VesselData>(ajax),
            observable: searchText,
            displayKey: function (v) {
                return v.Name || '';
            },
            templates: {
                suggestion: function (v : VesselData) {
                    var vesselId = '<div style="margin:0 0 10px 18px; display:block;">' + (
                            v.IMO      && v.IMO.trim()      ? '<span style="width:150px; display:inline-block; margin-top: 4px;">IMO: '       + escapeHtml(v.IMO) + '</span> ' :
                            v.MMSID    && v.MMSID.trim()    ? '<span style="width:150px; display:inline-block; margin-top: 4px;">MMSI: '      + escapeHtml(v.MMSID) + '</span> ' :
                            v.CallSign && v.CallSign.trim() ? '<span style="width:150px; display:inline-block; margin-top: 4px;">Call Sign: ' + escapeHtml(v.CallSign) + '</span> ' :
                            v.VIN      && v.VIN.trim()      ? '<span style="width:150px; display:inline-block; margin-top: 4px;">VIN: '       + escapeHtml(v.VIN) + '</span> ' :
                            ''),
                        length = new NullableMeasurement(v.Length).convert(pierSettings.DefaultLengthUOM() ?? UOM.Foot).toString({ places: 0 }),
                        flag = data.Countries.index(v.FlagId !== null ? v.FlagId : -1)();

                    return escapeHtml(v.Name || '') + '  '
                        + vesselId
                        + '<span style="width: 125px; display: inline-block; margin-top: 4px;">Length: ' + escapeHtml(length) + '</span> '
                        + '<span style="width: 275px; display: inline-block; margin-top: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: bottom;">Flag: ' + escapeHtml(flag ? flag.Name() : '--') + '</span></div>';
                }
            },
            onSearchResults: function (_vessels : VesselData[]) {
                // TH: Anytime we get a vessel in search results, add it to the vessels cache
                // This is one main way vessels make it into the cache
                // AAH: how to get timestamp here?
                data.Vessels.update(new Date(), _vessels, []);
            },
            onSelect: (d : VesselData) => {
                let vessel = data.Vessels.update1(null, d);
                onSelect(vessel);
            }
        });

    return {
        Typeahead: vesselTypeahead
    };
}



// WEBPACK FOOTER //
// ./apps/portcall/localvesselsearch/model.ts